import posthog from 'posthog-js';
import { store } from '../stores';
import { savedFlags, toggleFeatureFlag } from '../stores/slices/feature-flags';

function initPosthog() {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST
  });
}

function syncPosthogFeatureFlags() {
  posthog.onFeatureFlags(() => {
    const { featureFlags } = store.getState();
    Object.entries(featureFlags).forEach(([flag, { isEnabled }]) => {
      const isEnabledOnPosthog = posthog.isFeatureEnabled(flag) ?? false;
      if (isEnabled !== isEnabledOnPosthog) {
        store.dispatch(toggleFeatureFlag({ flag: flag as keyof typeof featureFlags }));
      }
    });
  });
}

if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
  initPosthog();

  if (!savedFlags) {
    syncPosthogFeatureFlags();
  }
}

export enum Event {
  SessionNoteCopyButtonClick = 'session-note:copy-button-click',
  SessionNoteRatingButtonClick = 'session-note:rating-button-click',
  SessionNoteRequestButtonClick = 'session-note:request-button-click',
  SessionNoteRegenerateButtonClick = 'session-note:regenerate-button-click'
}
